import { Injectable } from '@angular/core';
import { State, Action, StateContext, Store } from '@ngxs/store';
import { OperatingMonthActions } from './operating-month.actions';
import { OperatingMonth } from '../../models/operating-month.model';
import { AlertService } from 'src/app/shared/store/alert/alert.service';
import { LocalizationService } from 'src/app/services/localization/localization.service';

import { MappingUtilsService } from 'src/app/services/utils/mapping-utils.service';
import { OperatingMonthService } from '../../services/operating-month.service';

export class OperatingMonthStateModel {
  public operatingMonth: OperatingMonth;
  public isLoadingOpratingMonth: boolean;
  public error: string;
}

const defaults = {
  operatingMonth: null,
  isLoadingOpratingMonth: false,
  error: null
};

@State<OperatingMonthStateModel>({
  name: 'operatingMonth',
  defaults
})
@Injectable()
export class OperatingMonthState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private operatingMonthService: OperatingMonthService,
    public store: Store,
  ) {}

  @Action(OperatingMonthActions.GetOperatingMonth)
  getOperatingMonth(ctx: StateContext<OperatingMonthStateModel>, {}: OperatingMonthActions.GetOperatingMonth) {
    ctx.patchState({ isLoadingOpratingMonth: true });
   return this.operatingMonthService.getOperatingMonth().subscribe({
    next: (response) =>
      ctx.dispatch(new OperatingMonthActions.GetOperatingMonthSuccess(response)),
    error: (error) =>
      ctx.dispatch(new OperatingMonthActions.Error(error))
   });
  }

  @Action(OperatingMonthActions.GetOperatingMonthSuccess)
  getOperatingMonthSuccess(ctx: StateContext<OperatingMonthStateModel>, { operatingMonth }: OperatingMonthActions.GetOperatingMonthSuccess) {
    ctx.patchState({
      operatingMonth,
      isLoadingOpratingMonth: false
    });
  }

  @Action(OperatingMonthActions.Error)
  error(ctx: StateContext<OperatingMonthStateModel>, { error }: OperatingMonthActions.Error) {
    ctx.patchState({ isLoadingOpratingMonth: false });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  private getTitle() {
    return this.localizationService.translate('operating-month.title');
  }
}
